<template>
	<div id="auth-layout">
		<div class="container-fluid h-100">
			<div class="row h-100">
				<div class="col">
					<!-- Logo Data -->
				</div>

				<div class="col h-100">
					<blurry-card class="row h-100 justify-content-center align-items center">
						<div class="auth-back-btn" v-if="prev !== false">
							<b-button
								:to="prev"
								variant="light"
							>
								<font-awesome-icon icon="angle-left" />
							</b-button>

							{{ $t('auth.login_link') }}
						</div>
						<slot></slot>
					</blurry-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BlurryCard from '../../components/BlurryCard';

export default {
	components: {
		BlurryCard
	},

	props: {
		prev: { default: false }
	}
};
</script>

<style lang="scss">
html,
body {
	height: 100%;
}
</style>

<style lang="scss">
#auth-layout {
	background: url("../../../assets/auth_bg.png") no-repeat center center fixed;
	background-size: cover;
	height: 100%;

	h1 {
		color: #4d4f5c;
		font-size: 20px;
		opacity: 0.5;
		margin-bottom: 3em;
		text-align: center;
	}

	.btn {
		.spinner-border {
			position: relative;
			top: -3px;
		}
	}

	.auth-back-btn {
		position: absolute;
		top: 15px;
		left: 15px;
		font-size: 14px;
		line-height: 38px;

		.btn {
			margin-right: 10px;
		}
	}
}
</style>
